import { FC } from "react";

interface HeaderColumnPropTypes {
  label: string;
  alignLabel?: "text-left" | "text-center" | "text-right";
}

const HeaderColumn: FC<HeaderColumnPropTypes> = ({ label, alignLabel }) => {
  return (
    <th>
      <div
        className={
          "column-header" + (alignLabel ? ` ${alignLabel}` : " text-left")
        }
      >
        {label}
      </div>
    </th>
  );
};

export default HeaderColumn;
